'use client';
import { createRef, useEffect, useState } from 'react';
import cn from 'classnames';
import { SlidesRef } from 'antd-mobile/es/components/image-viewer/slides';
import ImageViewer from 'antd-mobile/es/components/image-viewer';
import Image from 'antd-mobile/es/components/image';
import Swiper from 'antd-mobile/es/components/swiper';
import { CloseCircleOutline } from 'antd-mobile-icons';
import { PhotoAlbumBulkFragment } from '@graphqlTypes/sitecore';
import { withFullPath } from '@src/utils/util';
import style from './index.module.scss';
import { jsBridge } from '@src/utils/js-bridge';
import styles from './index.module.scss';

type Props = {
    content: PhotoAlbumBulkFragment;
};

const PhotoAlbum = (props: Props) => {
    const [visible, setVisible] = useState(false);
    const [currentIndex, setCurrentIndex] = useState<number>();
    const [windowSize, setWindowSize] = useState<number>();
    const ImagePreviewRef = createRef<SlidesRef>();
    const { albumDisplayLayout, albumPhotosSelection } = props.content;

    const onHandleResize = () => {
        setTimeout(() => {
            setWindowSize(window.innerWidth);
        }, 200);
    };

    useEffect(() => {
        if (typeof window !== undefined) {
            window.addEventListener('resize', onHandleResize);
        }
        return () => {
            window.removeEventListener('resize', onHandleResize);
        };
    }, []);

    useEffect(() => {
        if (visible) {
            jsBridge.onBackBtnClicked = () => {
                setVisible(false);
                return true;
            };
        } else {
            jsBridge.onBackBtnClicked = undefined;
        }
        return () => {
            jsBridge.onBackBtnClicked = undefined;
        };
    }, [visible]);

    useEffect(() => {
        if (visible) {
            setVisible(false);
            ImagePreviewRef?.current?.swipeTo(currentIndex || 0, true);
            setVisible(true);
            console.log('enlarge windowSize', windowSize);
        }
    }, [windowSize, visible, currentIndex, ImagePreviewRef]);

    const SwiperItems = albumPhotosSelection?.targetItems?.map((item, index) => {
        return (
            <Swiper.Item key={index}>
                <div
                    onClick={() => {
                        ImagePreviewRef?.current?.swipeTo(index);
                        setCurrentIndex(index);
                        setVisible(true);
                    }}
                >
                    <Image lazy src={withFullPath(item.url)} alt='' />
                    <div
                        className={cn(
                            'absolute w-full flex justify-end bottom-0 bg-black p-[10px] gap-5 items-center',
                            styles.slidImgDes
                        )}
                    >
                        <div
                            className={cn(
                                'bg-[#CCC] text-black py-[1px] px-[10px] rounded-2xl',
                                styles.slideImgTotal
                            )}
                        >{`${index + 1} / ${albumPhotosSelection?.targetItems?.length}`}</div>
                    </div>
                </div>
            </Swiper.Item>
        );
    });

    const previewImages =
        albumPhotosSelection?.targetItems?.map((item) => withFullPath(item.url)) || [];

    const ImagePreview = (
        <ImageViewer.Multi
            ref={ImagePreviewRef}
            images={previewImages}
            visible={visible}
            onClose={() => setVisible(false)}
            classNames={{
                mask: '!bg-[#000000]',
            }}
            onIndexChange={setCurrentIndex}
            renderFooter={() => (
                <div className='fixed right-5 top-8' onClick={() => setVisible(false)}>
                    <CloseCircleOutline width={30} height={30} color='#FFFFFF' />
                </div>
            )}
        />
    );

    const Slider = (
        <>
            <Swiper>{SwiperItems}</Swiper>
            {ImagePreview}
        </>
    );

    const Gallery = (
        <>
            <div className='grid grid-cols-2 gap-4'>
                {albumPhotosSelection?.targetItems?.map((item, index) => {
                    return (
                        <div
                            key={index}
                            onClick={() => {
                                ImagePreviewRef?.current?.swipeTo(index);
                                setCurrentIndex(index);
                                setVisible(true);
                            }}
                        >
                            <Image lazy src={withFullPath(item.url)} alt='' />
                        </div>
                    );
                })}
            </div>
            {ImagePreview}
        </>
    );

    return (
        <div className={style.photoAlbum}>
            {albumDisplayLayout?.value === 'Slider' ? Slider : Gallery}
        </div>
    );
};

export default PhotoAlbum;
